import React from 'react';
import s from './SophisticatedTooltipText.scss';

interface Props {}

const SophisticatedTooltipText: React.FC<React.PropsWithChildren<Props>> = ({ children }) => {
  return <span className={s['root']}>{children}</span>;
};
SophisticatedTooltipText.displayName = 'SophisticatedTooltipText';

export default SophisticatedTooltipText;
